import { render } from "./mcabecalho.vue?vue&type=template&id=28a54766"
import script from "./mcabecalho.vue?vue&type=script&lang=js"
export * from "./mcabecalho.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__